import { AchieveLink } from 'components/AchieveLink/AchieveLink'
import { Button, Typography } from '@achieve/ascend'
import { SIGN_IN_ROUTE } from 'constants/navigation'
import { mainProductConfig } from 'constants/mainProductConfig'
import { useContext } from 'react'
import { LayoutContext } from 'providers/LayoutProvider'
import classNames from 'classnames'
import { FdrPage } from 'utils/environmentConfig'

function SignInLink({
  disabledRoutes = [],
  signInLinkUrl,
  signInLinkText,
  event,
  outlined,
  textClassName = '',
  ...restProps
}) {
  const { state: { siteEnv } = {} } = useContext(LayoutContext)
  if (disabledRoutes.includes(SIGN_IN_ROUTE)) {
    return null
  }

  return (
    <AchieveLink
      color="primary"
      href={signInLinkUrl ? signInLinkUrl : SIGN_IN_ROUTE}
      track={{
        ...{
          list_name: 'Header Nav Sign in Link',
          click_id: 'Sign in',
          click_text: `${mainProductConfig[siteEnv || 'achieve']?.['MainProductHyphen']} | Sign in`,
          nav_link_section: 'Header',
          track_event: 'global_header',
          event_action: 'link_click',
          event_type: 'link_click',
        },
        ...event,
      }}
      variant="bodySm"
      {...restProps}
    >
      {outlined ? (
        <Button color="secondary" variant="contained" className={classNames('flex flex-row gap-2', {'py-[6px]': siteEnv === FdrPage})} size="small">
          <Typography className={textClassName} fontWeight="medium">
            {signInLinkText ? signInLinkText : `Sign in`}
          </Typography>
        </Button>
      ) : (
        <Typography className={textClassName} fontWeight="medium">
          {signInLinkText ? signInLinkText : `Sign in`}
        </Typography>
      )}
    </AchieveLink>
  )
}

export { SignInLink }
